import type { SVGProps } from "react";
import * as React from "react";

export const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 21"
    className="fill-current"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="m10 2.421 2.575 5.217 5.758.841-4.166 4.059.983 5.733L10 15.563 4.85 18.27l.983-5.733-4.166-4.059 5.758-.841z"
    />
  </svg>
);
